import React, {Component} from 'react';

import {BonusPointsOverview} from "../utils/types";
import Cookie from "../utils/cookies";
import LocResourcesContext, {LocResourcesContextProps} from '../contexts/LocResourcesContext';
import gradient from "../assets/img/gradient.png";
import zooPoints from '../assets/img/zooPoints.svg';

interface CustomerBalanceProps {
    redeemableBalance: number;
    bonusPointsOverview: BonusPointsOverview;
    hasAnyRedemption: boolean;
    showRewardShopButton: boolean;
    isRewardShopPage: boolean;
}

interface CustomerBalanceStates {
    barMode: boolean;
    firstExpiringDate: Date | undefined;
    firstExpiringBalance: number | undefined;
}

export default class CustomerBalance extends Component<CustomerBalanceProps, CustomerBalanceStates> {

    private readonly boxRef: React.RefObject<unknown>;

    constructor(props: CustomerBalanceProps) {
        super(props);

        const hasExpiringBalance = !!this.props.bonusPointsOverview.expiryDate && !!this.props.bonusPointsOverview.expiringBalance;

        this.state = {
            barMode: false,
            firstExpiringDate: hasExpiringBalance ? new Date(this.props.bonusPointsOverview.expiryDate) : undefined,
            firstExpiringBalance: hasExpiringBalance ? this.props.bonusPointsOverview.expiringBalance : undefined
        };

        this.boxRef = React.createRef();
    }

    onFormatLocale (localeKey: string, params: any = undefined): string {
        return (this.context as LocResourcesContextProps).onFormatLocale(localeKey, params);
    }

    onFormatDate (date: Date): string {
        return (this.context as LocResourcesContextProps).onFormatDate(date);
    }

    getBarModeClass() {
        return this.state.barMode ? 'bar-mode' : '';
    }

    checkBoxVisibility() {
        this.setState({barMode: !this.isElementVisible(this.boxRef.current)});
    }

    componentDidMount() {
        window.addEventListener('scroll', () => this.checkBoxVisibility());
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', () => this.checkBoxVisibility());
    }

    isElementVisible(element: any) {
        return element.getBoundingClientRect().top + this.getDummyBoxHeight() >= 0;
    }

    getDummyBoxHeight(){
        const isMobile = (window.innerWidth || document.documentElement.clientWidth) <= 543;
        return isMobile ? 110 : 80;
    }

    isMobileApp() {
        const isMobile = Cookie.get("MOBILE_APP")
        return isMobile !== undefined;
    }

    customerBalance() {
        const showWhatAreZoopointsButton = (!this.props.hasAnyRedemption && !this.props.showRewardShopButton);
        const showRewardShopButton = (this.props.showRewardShopButton);
        const isRewardShopPage = (this.props.isRewardShopPage);
        const hasExpiring = (this.state.firstExpiringDate)
            && (this.state.firstExpiringBalance)
            && (this.state.firstExpiringBalance > 0);

        const lastExpiring = hasExpiring ? <React.Fragment>
            <span className="loy-bpo-balance-v2_section_header v3-p2"
                  data-grid-v3="col-start-1 col-12 col-start-5@md col-3@md row-start-3 row-1 row-start-1@md row-1@md">
                {this.onFormatLocale("loy.points.expiry") + " "}
                <span>{this.onFormatDate(this.state.firstExpiringDate)}</span>
            </span>
            <div className="loy-bpo-balance-v2_section_value v3-h3"
                 data-grid-v3="col-start-1 col-12 col-start-5@md col-3@md row-start-4 row-1 row-start-2@md row-1@md">
                {this.state.firstExpiringBalance}
            </div>
        </React.Fragment>: "";

        const whatAreZoopointsButton = <a href="/account/bonuspoints/overview#loy-bppo-what-are-zoopoints"
                                          id="loy-bppo-what-are-zoopoints"
            // @ts-ignore
                                          onClick={() => SendAdobeData('bpFilter', 'event552')}
                                          className={"v3-btn v3-btn--fullWidth loy-bpo-balance-v2_rewardShopButton"}>
            {this.onFormatLocale("loy.bp.what-are-zoopoints")}
        </a>;

        const rewardShopButton = <a href="/account/bonuspoints/products/overview"
                                    className={"v3-btn v3-btn--fullWidth loy-bpo-balance-v2_rewardShopButton" }
            // @ts-ignore
                                    onClick={() => SendAdobeData('clickTrack', '^tm:Loyalty^trk:Bonus Points^val:Account Page / Reward Shop Button')}>
            {this.onFormatLocale("loy.rewardshop.link")}
        </a>;

        const hideBox = (this.state.barMode && isRewardShopPage) || !this.props.redeemableBalance;

        // @ts-ignore
        return [<div ref={this.boxRef} className={"loy-bpo-balance-v2_container_dummy " + this.getBarModeClass() + (isRewardShopPage ? '' : ' hidden') + (' height' + this.getDummyBoxHeight())}/>,
            <div className={"loy-bpo-balance-v2_container bar-mode " + (this.state.barMode && this.props.redeemableBalance && isRewardShopPage ? '' : 'hidden') + (this.isMobileApp() ? ' top0' : '')}>
                <i className="v5-icon--collect-mid"/>
                <span className="text">{this.onFormatLocale("loy.points.available")}</span>
                <span className="balance">
                        {this.props.redeemableBalance + ' ' + this.onFormatLocale("mzp.points.points")}
                    </span>
            </div>,
            <div className={"loy-bpo-balance-v2 loy-bpo-balance-v2_container "+ (hideBox ? 'hidden' : '')} data-grid-v3={hideBox ? '' : "grid gap-none"}>
                <div className="loy-bpo-balance-v2_section"
                     data-grid-v3="grid-rows-4 grid-rows-2@md col-start-1 col-12 col-start-1@md col-7@md">
                    <div className="loy-bpo-balance-v2_points_container">
                        <div className="loy-bpo-balance-v2_points_data"
                             data-grid-v3="col-start-1 col-12 col-start-1@md col-4@md">
                                <span className="loy-bpo-balance-v2_section_header v3-p2"
                                      data-grid-v3="col-start-1 col-12 col-start-1@md col-4@md row-start-1 row-1 row-start-1@md row-1@md">
                                    {this.onFormatLocale("loy.points.available")}
                                </span>
                            <div className="loy-bpo-balance-v2_section_value v3-h3"
                                 data-grid-v3="col-start-1 col-12 col-start-1@md col-4@md row-start-2 row-1 row-start-2@md row-1@md">
                                {this.props.redeemableBalance}
                            </div>
                        </div>
                        <div className="loy-bpo-balance-v2_points_data"
                             data-grid-v3="col-start-1 col-12 col-start-5@md col-4@md">
                            {lastExpiring}
                        </div>
                    </div>
                </div>
                <div className="loy-bpo-balance-v2_section_cta"
                     data-grid-v3="grid-rows-2 col-start-1 col-12 col-start-8@md col-5@md">
                    {showRewardShopButton && rewardShopButton}
                    {showWhatAreZoopointsButton && whatAreZoopointsButton}
                    <div className="loy-bpo-balance-v2__decoration">
                        <img className="loy-bpo-balance-v2__decoration--big-icon"
                             src={zooPoints as any as string}/>
                        <img className="loy-bpo-balance-v2__decoration--small-icon"
                             src={zooPoints as any as string}/>
                        <img className="loy-bpo-balance-v2__decoration--gradient"
                             src={gradient}/>
                    </div>
                </div>
            </div>]
    }

    render() {
        return this.customerBalance();
    }
};
CustomerBalance.contextType = LocResourcesContext as React.Context<LocResourcesContextProps>;
